export default () => ({
  one: true,
  two: false,
  three: false,

  toggleone() {
    this.one = true
    this.two = false
    this.three = false
    this.focusHeading(this.$el);
    
  },
  get classone() {
      return this.one ? 'open' : ''
  },

  toggletwo() {
    this.one = false
    this.two = true
    this.three = false
    this.focusHeading(this.$el);
  },
  get classtwo() {
      return this.two ? 'open' : ''
  },

  togglethree() {
    this.one = false
    this.two = false
    this.three = true
    this.focusHeading(this.$el);
  },
  get classthree() {
      return this.three ? 'open' : ''
  },

  focusHeading(el) {
    setTimeout(() => {
      // console.log(el);
      if(window.outerWidth < 768) {
        let toPoint = Math.floor(el.getBoundingClientRect().top + document.documentElement.scrollTop) - document.querySelector('.header').offsetHeight;
        // console.log(toPoint)
        window.scrollTo({
          top: toPoint,
          behavior: 'smooth'
        })
      }
    }, 300)
  }


 
})